import { template } from "@ember/template-compiler";
import DiagnosticFields from '../not-donor/diagnostic-fields';
import { eq } from 'ember-truth-helpers';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import type { TOC } from '@ember/component/template-only';
interface Signature {
    Args: {
        form: unknown;
    };
}
const MyComponent: TOC<Signature> = template(`
  <div class='field'>
    {{! @glint-expect-error }}
    <@form.Dropdown
      @propertyName='mrcStage'
      @labelName='Stade'
      @translationKey='fur.mrc-stage'
      @isMandatory={{true}}
      as |dropdown|
    >
      <dropdown.Item @key='stage-undefined' />
      <dropdown.Item @key='stage-1' />
      <dropdown.Item @key='stage-2' />
      <dropdown.Item @key='stage-3' />
      <dropdown.Item @key='stage-3-a' />
      <dropdown.Item @key='stage-3-b' />
      <dropdown.Item @key='stage-4' />
      <dropdown.Item @key='stage-5' />
      <dropdown.Item @key='hemodialysis' />
      <dropdown.Item @key='peritoneal-dialysis' />
      {{! @glint-expect-error }}
    </@form.Dropdown>
  </div>

  {{! @glint-expect-error }}
  {{#if (eq (changesetGet @form.changeset 'mrcStage') 'hemodialysis')}}
    <div class='field'>
      {{! @glint-expect-error }}
      <@form.Dropdown
        @propertyName='hemodialysisType'
        @labelName="Type d'hémodialyse"
        @translationKey='fur.hemodialysis-type'
        as |dropdown|
      >
        <dropdown.Item @key='at-home' />
        <dropdown.Item @key='in-udm' />
        <dropdown.Item @key='in-self-dialysis-unit' />
        {{! @glint-expect-error }}
      </@form.Dropdown>
    </div>
  {{/if}}

  <div class='field'>
    {{! @glint-expect-error }}
    <@form.BasicRadioGroup
      @title='Greffe pré existante'
      @propertyName='mrcPreexistingTransplant'
      @errorClass='left-aligned-validation-error-message'
      as |Group|
    >
      <div class='fields'>
        <div class='field'>
          <Group.Radio @label='Oui' @value={{true}} />
        </div>
        <div class='field'>
          <Group.Radio @label='Non' @value={{false}} />
        </div>
        <div class='field'>
          <Group.Radio @label='Non renseigné' @value={{null}} />
        </div>
      </div>
      {{! @glint-expect-error }}
    </@form.BasicRadioGroup>
  </div>

  <DiagnosticFields @form={{@form}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default MyComponent;
